import { RightSideBarModule } from '@src/slide/application/service/right-side-bar-service/core/right-side-bar-module';
import OcrRightSidebar from '../ocr-right-sidebar';
import ReactDOM from 'react-dom';
import { IOcrSideBarManager, IOcrSideBarManagerServiceDelegates } from './interface';

export const MODULE_NAME = 'ocr-sidebar';

export class OcrSideBarRSBarModule extends RightSideBarModule {
    private hideSidebarCallback: () => void;
    public constructor(private ocrSideBarManager: OcrSideBarManager) {
        super();
    }

    public get name() {
        return MODULE_NAME;
    }

    public show = (config) => {
        this.ocrSideBarManager.showModule({
            config,
            DOMNode: this.DOMNode,
            onShow: () => {
                this.showWrapper();
            },
            onClose: () => {
                this.hideWrapper();
            },
        });
        this.hideSidebarCallback = config?.hideSidebarCallback;
    };

    public hide = () => {
        this.hideWrapper();
    };

    public hideWrapper = () => {
        super.hideWrapper();
        const dom = this.DOMNode as Element;
        dom && ReactDOM.unmountComponentAtNode(dom);
        this.hideSidebarCallback?.();
    };
}

export default class OcrSideBarManager implements IOcrSideBarManager {
    public module: any = OcrRightSidebar; // react dom组件
    private services: IOcrSideBarManagerServiceDelegates;
    public setServiceDelegates(services: Partial<IOcrSideBarManagerServiceDelegates>) {
        this.services = {
            ...this.services,
            ...services,
        };
    }

    public registerRightSideBar() {
        this.services.rightSideBarService.registerModule(new OcrSideBarRSBarModule(this));
    }

    public showModule({ DOMNode, config, onShow, onClose }) {
        this.module?.initDom(DOMNode, config);
        onShow?.();
    }

    public show = (config) => {
        this.services.rightSideBarService.show(MODULE_NAME, config);
    };

    public hide = () => {
        this.services.rightSideBarService.hide();
        this.services.rightSideBarService.resetWidth();
    };
}
